class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  
    open(triggeredBy) {
      document.dispatchEvent(new CustomEvent("mini-cart-open"));
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {this.classList.add('animate', 'active')});
  
      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
      document.dispatchEvent(new CustomEvent("mini-cart-close"));
    }
  
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
  
      if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
  
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
  
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  
    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
  
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
  
    
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }
  
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);
  
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  }
  
  customElements.define('cart-drawer-items', CartDrawerItems);
  

  // ================================================
// ✅ Rebuy Event Listeners for tracking + cart refresh
// ================================================

// We'll attach the popup handler after DOMContentLoaded so helpers are in scope

document.addEventListener('DOMContentLoaded', function () {
  
  // Block redirects to cart when Rebuy popup is visible
  (function setupRebuyRedirectGuards() {
    var originalAssign = window.location.assign.bind(window.location);
    var originalReplace = window.location.replace.bind(window.location);
    var hrefDescriptor = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
    var rebuyJustAddedUntil = 0;
    function popupVisible() {
      return !!document.querySelector('.rebuy-widget-container.widget-display-popup.is-visible, .rebuy-widget-container.widget-display-embed.is-visible');
    }
    function isCartUrl(url) {
      try { return /\/cart(\/?|$|[#?])/.test(String(url)); } catch (e) { return false; }
    }
    function shouldBlock(url) {
      var now = Date.now();
      var recent = now < rebuyJustAddedUntil;
      return (popupVisible() || recent) && isCartUrl(url);
    }
    // Mark a short suppression window after any rebuy.add
    document.addEventListener('rebuy.add', function() {
      rebuyJustAddedUntil = Date.now() + 2000; // 2s window
    });
    window.location.assign = function(url) {
      if (shouldBlock(url)) return;
      return originalAssign(url);
    };
    window.location.replace = function(url) {
      if (shouldBlock(url)) return;
      return originalReplace(url);
    };
    // Intercept direct href assignments
    if (hrefDescriptor && hrefDescriptor.configurable) {
      Object.defineProperty(Location.prototype, 'href', {
        configurable: true,
        enumerable: hrefDescriptor.enumerable,
        get: function() { return hrefDescriptor.get.call(this); },
        set: function(value) {
          if (shouldBlock(value)) return;
          return hrefDescriptor.set.call(this, value);
        }
      });
    }
    // Prevent anchor clicks to cart inside popup
    document.addEventListener('click', function(e) {
      var anchor = e.target.closest('a[href]');
      if (!anchor) return;
      if (!anchor.closest('.rebuy-widget-container.widget-display-popup.is-visible, .rebuy-widget-container.widget-display-embed.is-visible')) return;
      var href = anchor.getAttribute('href') || '';
      if (isCartUrl(href)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  })();


  // Intercept Rebuy popup/embed add-to-cart clicks and add via AJAX
  document.addEventListener('click', function(event) {
    const rebuyButton = event.target.closest('.rebuy-button');
    if (!rebuyButton) return;

    const rebuyContainer = rebuyButton.closest('.rebuy-widget-container.widget-display-popup.is-visible, .rebuy-widget-container.widget-display-embed.is-visible');
    if (!rebuyContainer) return;

    const variantId = rebuyButton.getAttribute('data-variant-id');
    const qtyAttr = rebuyButton.getAttribute('data-quantity');
    const quantity = parseInt(qtyAttr || '1', 10) || 1;
    const productId = rebuyButton.getAttribute('data-product-id');
    const productTitle = rebuyButton.getAttribute('data-product-title');

    if (!variantId) return; // Let default behavior if we can't determine variant

    event.preventDefault();
    event.stopPropagation();

    // Button UI state: Adding...
    var labelEl = rebuyButton.querySelector('span');
    var originalLabelHTML = labelEl ? labelEl.innerHTML : '';
    rebuyButton.classList.add('working');
    rebuyButton.setAttribute('disabled', 'disabled');
    if (labelEl) labelEl.innerHTML = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      // Button UI state: Added!
      if (labelEl) labelEl.innerHTML = 'Added!';
      rebuyButton.classList.remove('working');
      setTimeout(function() {
        if (labelEl) labelEl.innerHTML = originalLabelHTML;
        rebuyButton.removeAttribute('disabled');
      }, 1200);

      const detail = {
        product: {
          id: Number(productId) || undefined,
          title: productTitle || undefined,
          selected_variant: { id: Number(variantId) },
          quantity: quantity
        }
      };
      document.dispatchEvent(new CustomEvent('rebuy.add', { detail }));
      openCartDrawerAndRefresh();
    })
    .catch(function(err) {
      // Reset UI on failure
      if (labelEl) labelEl.innerHTML = originalLabelHTML;
      rebuyButton.classList.remove('working');
      rebuyButton.removeAttribute('disabled');
    });
  }, true);

  // --- rebuy.add
  document.addEventListener('rebuy.add', function (event) {

    const product = event.detail?.product;
    if (product) {
      document.dispatchEvent(
        new CustomEvent('RebuyAddToCart', {
          detail: {
            productID: product.id,
            productTitle: product.title,
            variantID: product.selected_variant?.id,
            quantity: product.quantity || 1,
            source: 'rebuy_widget',
          },
        })
      );
    }

    openCartDrawerAndRefresh();
  });

  // --- rebuy.change
  document.addEventListener('rebuy.change', function (event) {
    refreshCartSections();
  });

  document.addEventListener('rebuy.remove', function (event) {
    refreshCartSections();
  });

  // ------------------- Helpers -------------------
  function ensureRebuyWidgetVisibleAndInitialized() {
    const wrapper = document.querySelector('#CartDrawer .cart-Rebuy-widget') || document.querySelector('.cart-Rebuy-widget');
    if (!wrapper) return;

    const forceShow = () => {
      const container = wrapper.querySelector('.rebuy-widget-container');
      if (container) {
        container.classList.remove('is-hidden');
        container.classList.add('is-visible');
      }
    };

    const tryInit = () => {
      try {
        if (window.Rebuy && typeof window.Rebuy.init === 'function') {
          window.Rebuy.init();
        } else if (window.Rebuy && typeof window.Rebuy.reload === 'function') {
          window.Rebuy.reload();
        }
      } catch (e) {}
    };

    const hasProducts = () => !!wrapper.querySelector('.rebuy-product-block');

    forceShow();
    if (hasProducts()) return;

    tryInit();

    let attempts = 0;
    const maxAttempts = 10;
    const poll = () => {
      forceShow();
      if (hasProducts() || attempts >= maxAttempts) return;
      attempts += 1;
      if (attempts === 1 || attempts === 3 || attempts === 6) tryInit();
      setTimeout(poll, 80);
    };
    setTimeout(poll, 40);
  }
  function openCartDrawerAndRefresh() {
    fetch('/cart.json')
      .then((res) => res.json())
      .then((cartData) => {
        refreshCartSections(cartData);
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer?.renderContents) {
          fetchSections(['cart-drawer', 'cart-icon-bubble']).then((sections) => {
            // Preserve the live Rebuy widget node (keeps dynamic product list and listeners)
            const preservedNode = document.querySelector('.cart-Rebuy-widget') || null;
            if (preservedNode && preservedNode.parentElement) preservedNode.parentElement.removeChild(preservedNode);

            cartDrawer.renderContents({ id: 'rebuy-added', sections });

            // After render, replace any new widget with the preserved live node
            requestAnimationFrame(() => {
              const newWidget = document.querySelector('#CartDrawer .cart-Rebuy-widget') || document.querySelector('.cart-Rebuy-widget');
              const insertionTarget = (document.querySelector('#CartDrawer .drawer__footer') || document.querySelector('.drawer__footer'))?.parentElement
                || document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('.drawer__inner');

              if (preservedNode) {
                if (newWidget && newWidget !== preservedNode) {
                  newWidget.replaceWith(preservedNode);
                } else if (insertionTarget && !document.body.contains(preservedNode)) {
                  insertionTarget.appendChild(preservedNode);
                }
                ensureRebuyWidgetVisibleAndInitialized();
              }
              // If we didn't preserve, still ensure the widget initializes if present in new HTML
              if (!preservedNode) ensureRebuyWidgetVisibleAndInitialized();
            });
          });
        } else {
          openCartDrawer();
        }

        document.dispatchEvent(new CustomEvent('cartUpdated', { detail: { cart: cartData } }));
      })
      .catch((err) => {
        openCartDrawer();
      });
  }

  function fetchSections(sectionNames) {
    return fetch('/?sections=' + sectionNames.join(','), {
      headers: { 'Accept': 'application/json' },
    })
      .then((r) => r.json())
      .catch((e) => {
        return {};
      });
  }

  function refreshCartSections(cartData) {
    if (!cartData) {
      fetch('/cart.json')
        .then((r) => r.json())
        .then(refreshCartSections);
      return;
    }

    const count = cartData.item_count;
    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.textContent = count;
      bubble.style.display = count > 0 ? 'block' : 'none';
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', count === 0);
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.open) drawer.open();
    else document.querySelector('#cart-icon-bubble')?.click();
  }
});